import { fetchWithCache, saveToCache } from '../tools/sessionCache'
import clientHttp from '../tools/clientHttp'
import filterByPermissions from '../tools/filterByPermissions'

const URL = "/employs";
let employeesItems = [];

export const updatedCacheEmployees = async (data) => {
    await saveToCache(btoa(URL), data);
}

export const getEmployees = async () => {
    //const permissionsFingerprint = `${user.level}_${user.costCenters.sort().join('-')}`;
    const { data, dataCached } = await fetchWithCache(URL);

    const filteredData = filterByPermissions(data || []);

    if (filteredData.length > 0) {
        filteredData.sort((a, b) => a.firstName.localeCompare(b.firstName));
    }

    if (employeesItems.length === 0 || !dataCached) {
        employeesItems = filteredData.map(employee => ({
            text: `${employee.rut} - ${employee.firstName} ${employee.fatherName} ${employee.motherName}`,
            value: employee.id,
            sex: employee.gender,
        }))
    }
    return {
        employees: filteredData, employeesItems
    }
}

export const getEmployeesWithKits = async () => {
    const { data } = await fetchWithCache(`${URL}/get-massive`);
    const filteredData = filterByPermissions(data || []);
    if (filteredData && filteredData.length > 0) {
        filteredData.sort((a, b) => a.firstName.localeCompare(b.firstName));
    }
    return filteredData;
}

export const getEmployeesCount = async () => {
    const { data } = await fetchWithCache(`${URL}/count`);
    return data.totalEmployees;
}

export const getEmployeesItems = async () => {
    return employeesItems.length > 0 ? employeesItems : (await getEmployees()).employeesItems;
}

export const getCostCenters = async (flagAll = false) => {
    const employees = (await getEmployees()).employees;
    const costCenters = [...new Set(employees.map(employee => employee.costCenter))];
    const sortedCostCenters = costCenters.sort((a, b) => a.localeCompare(b));
    const result = [
        ...sortedCostCenters.map(costCenter => ({
            text: costCenter,
            value: costCenter
        }))
    ];
    if (flagAll) result.unshift({ text: "TODOS", value: "All" });
    return result;
}

export const getPositions = async (costCenter = 'All') => {
    const employees = await getEmployeesByCostCenter(costCenter, true);
    const positions = [...new Set(employees.map(employee => employee.position))];
    const sortedPositions = positions.sort((a, b) => a.localeCompare(b));
    return [
        ...sortedPositions.map(position => ({
            text: position,
            value: position
        }))
    ];
}

export const getEmployeesByPosition = async (position) => {
    const employees = (await getEmployees()).employees;
    const filteredEmployees = employees.filter(employee => employee.position.toLowerCase() === position.toLowerCase());
    return filteredEmployees.map(employee => ({
        text: `${employee.rut} - ${employee.firstName} ${employee.fatherName} ${employee.motherName}`,
        value: employee.id
    }));
}

export const getEmployeesByCostCenter = async (costCenter, fullResponse = false) => {
    //if(costCenter === "All") return (await getEmployees()).employeesItems;
    const employees = (await getEmployees()).employees;
    const filteredEmployees = costCenter === "All" ? employees : employees.filter(employee => employee.costCenter.toLowerCase() === costCenter.toLowerCase());
    return fullResponse ? filteredEmployees : filteredEmployees.map(employee => ({
        text: `${employee.rut} - ${employee.firstName} ${employee.fatherName} ${employee.motherName}`,
        value: employee.id
    }));
}

export const getFilteredEmployees = async (filters = {}) => {
    const { employees } = await getEmployees();

    return employees.filter(employee => {
        return Object.entries(filters).every(([key, value]) => {
            if (value === undefined || value === null || value === '') return true;
            if (key === 'costCenter' && value === 'All') return true;
            if (key === 'gender' && value === 'U') return true;
            const employeeValue = employee[key];
            if (employeeValue === null || employeeValue === undefined) return false;
            return employee[key].toLowerCase() === value.toLowerCase();
        });
    }).map(employee => ({
        text: `${employee.firstName} ${employee.fatherName} ${employee.motherName}`,
        value: employee.id,
        costCenter: employee.costCenter,
        position: employee.position,
        gender: employee.gender
    }));
}

export const updateEmployee = async (id, data) => {
    deletePropertiesNotEntity(data);
    const response = await clientHttp.patch(`/employs/${id}`, data);
    return response.data;
}

export const createEmployee = async (data, bulk = false) => {
    try {
        deletePropertiesNotEntity(data);
        const response = await clientHttp.post(`/employs`, data, { keepLoading: bulk });
        return {
            success: true,
            ...response.data
        }
    } catch (error) {
        console.log("🚀 ~ createEmployee ~ error:", error)
        return {
            success: false,
        }
    }
}

const deletePropertiesNotEntity = (data) => {
    if (data.employeeName) delete data.employeeName
    if (data.calzado) delete data.calzado
    if (data.pantalon) delete data.pantalon
    if (data.uniforme) delete data.uniforme
    if (data.createItem) delete data.createItem
    if (data.flag) delete data.flag
}